var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarMast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7204 1.06325C10.725 0.719929 10.6234 0.425011 10.4866 0.384521H9.87949C9.74353 0.428852 9.6457 0.684476 9.6457 1.06325C9.6457 1.44203 9.36772 13.002 9.23047 18.9192C9.23047 19.3107 9.39447 19.6153 9.61779 19.6153H10.7658C10.9891 19.6153 11.1636 19.3107 11.1531 18.9192C11.0019 12.9672 10.8577 7.01522 10.7204 1.06325Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84619 12.3077H16.1539",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.487 9.76929V10.9231H4.74341V11.6924H3.71777V10.9231H3.97418V9.76929H4.487Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64095 9C5.92417 9 6.15377 9.2296 6.15377 9.51282C6.15377 9.79604 5.92417 10.0256 5.64095 10.0256C5.45125 10.0256 5.2856 9.92264 5.1969 9.76951L3.26464 9.76925C3.17597 9.92252 3.01025 10.0256 2.82044 10.0256C2.53721 10.0256 2.30762 9.79604 2.30762 9.51282C2.30762 9.2296 2.53721 9 2.82044 9C3.01014 9 3.17578 9.103 3.26449 9.25613L5.19675 9.25639C5.28542 9.10312 5.45114 9 5.64095 9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0256 9.76929V10.9231H16.282V11.6924H15.2563V10.9231H15.5128V9.76929H16.0256Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1795 9C17.4627 9 17.6923 9.2296 17.6923 9.51282C17.6923 9.79604 17.4627 10.0256 17.1795 10.0256C16.9898 10.0256 16.8242 9.92264 16.7355 9.76951L14.8032 9.76925C14.7145 9.92252 14.5488 10.0256 14.359 10.0256C14.0758 10.0256 13.8462 9.79604 13.8462 9.51282C13.8462 9.2296 14.0758 9 14.359 9C14.5487 9 14.7144 9.103 14.8031 9.25613L16.7353 9.25639C16.824 9.10312 16.9897 9 17.1795 9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61523 5.38462H15.3845",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25605 2.84619V4.00004H5.51246V4.76927H4.48682V4.00004H4.74323V2.84619H5.25605Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40999 2.0769C6.69322 2.0769 6.92281 2.3065 6.92281 2.58972C6.92281 2.87295 6.69322 3.10255 6.40999 3.10255C6.22029 3.10255 6.05465 2.99954 5.96594 2.84641L4.03368 2.84615C3.94501 2.99943 3.77929 3.10255 3.58948 3.10255C3.30626 3.10255 3.07666 2.87295 3.07666 2.58972C3.07666 2.3065 3.30626 2.0769 3.58948 2.0769C3.77918 2.0769 3.94483 2.17991 4.03354 2.33304L5.96579 2.3333C6.05446 2.18002 6.22019 2.0769 6.40999 2.0769Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.256 2.84619V4.00004H15.5125V4.76927H14.4868V4.00004H14.7432V2.84619H15.256Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.41 2.0769C16.6932 2.0769 16.9228 2.3065 16.9228 2.58972C16.9228 2.87295 16.6932 3.10255 16.41 3.10255C16.2203 3.10255 16.0546 2.99954 15.9659 2.84641L14.0337 2.84615C13.945 2.99943 13.7793 3.10255 13.5895 3.10255C13.3063 3.10255 13.0767 2.87295 13.0767 2.58972C13.0767 2.3065 13.3063 2.0769 13.5895 2.0769C13.7792 2.0769 13.9448 2.17991 14.0335 2.33304L15.9658 2.3333C16.0545 2.18002 16.2202 2.0769 16.41 2.0769Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0558 13.6353L9.23047 16.5833",
    stroke: "white",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.906 7.56934L9.50146 10.5385",
    stroke: "white",
    strokeWidth: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0558 19.3858L9.23047 16.5833",
    stroke: "white",
    strokeWidth: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.056 13.6351L9.50146 10.5383",
    stroke: "white",
    strokeWidth: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9062 7.56923L9.70312 4.02175L10.7207 1.06323",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMast);
export default __webpack_public_path__ + "static/media/sidebar-mast.81881c78.svg";
export { ForwardRef as ReactComponent };